import { useWeb3React } from "@web3-react/core";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import useAuth from "../hooks/useAuth";
import Loader from "../hooks/loader";
import backendClient from "../utils/backendClient";
import { userPrivateKey, userSmartAccount } from "./recoilAtom";
import { useRecoilValue } from "recoil";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import useSignature from "../hooks/userSign";
const WalletConnectModel = ({
  route,
  showWallet,
  handleCloseWallet,
  show,
  theme,
  handleClose,
  internalAccountHandler,
}) => {
  const [trust, setTurst] = useState(false);
  const smartAccount = useRecoilValue(userSmartAccount);

  const privatekeyy = useRecoilValue(userPrivateKey);
  const { login, logout } = useAuth();
  let { account } = useWeb3React();
  const [errorMessage, setErrorMessage] = useState("Invalid PrivateKey");
  const [errorBool, setErrorBool] = useState(false);
  const [inputPrivateKeyInput, setInputPrivateKeyInput] = useState(null);
  const [showImportSmart, setShowImportSmart] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleCloseImportSmart = () => setShowImportSmart(false);
  // const handleShowImportSmart = () => setShowImportSmart(true);

  const [showCreateSmart, setShowCreateSmart] = useState(false);

  const handleCloseCreateSmart = () => setShowCreateSmart(false);
  // const handleShowCreateSmart = () => setShowCreateSmart(true);

  const [showsign, setShowSign] = useState(false);
  const handleCloseSign = () => setShowSign(false);
  const handleShowSign = () => setShowSign(true);

  const { userSign } = useSignature();

  const registerWithWallet = async (
    walletAddress,
    smartWalletAddress,
    sign
  ) => {
    const response = await backendClient.post(
      "/auth/login-or-register-with-walletAddress",
      route
        ? {
            walletAddress,
            userSmartAddress: smartWalletAddress,
            sign,
            referrer: route ? route : "",
          }
        : {
            walletAddress,
            userSmartAddress: smartWalletAddress,
            sign,
          }
    );

    return response.data; // expecting token
  };

  const connectWallet = async () => {
    try {
      if (account) {
        const connectorId = window.localStorage.getItem("connectorId");
        const res = await logout(connectorId);

        localStorage.removeItem("connectorId");
        localStorage.removeItem("flag");
      } else {
        await login("injected");
        localStorage.setItem("connectorId", "injected");
        localStorage.setItem("flag", "true");
        handleClose();
        setTurst(true);
        const walletAddress = window.ethereum.selectedAddress;
      }
    } catch (error) {
      console.error("Error in connectWallet:", error);

      localStorage.removeItem("connectorId");
      localStorage.removeItem("flag");
      localStorage.removeItem("sign");
    }
  };
  const trustWallet = async () => {
    try {
      if (account) {
        await logout("walletconnect");

        localStorage.removeItem("connectorId");
        localStorage.removeItem("flag");
        localStorage.removeItem("sign");
      } else {
        setTimeout(() => {}, 3000);
        await login("walletconnect");
        localStorage.setItem("connectorId", "walletconnect");
        localStorage.setItem("flag", "true");
        // const walletAddress = window.ethereum.selectedAddress;
        setTurst(true);

        // if (walletAddress) {
        //   // ✅ Register the user with walletAddress
        //   const res = await registerWithWallet(walletAddress);

        //   // ✅ Save token in localStorage
        //   if (res?.token) {
        //     localStorage.setItem("token", res.token);
        //   }
        // }
      }
    } catch (error) {
      localStorage.removeItem("connectorId");
      localStorage.removeItem("flag");
      console.error("Error during WalletConnect operation:", error);
    }
  };

  const [copy, setCopy] = useState(false);
  const CallCopy = () => {
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, [3000]);
  };

  const [copy1, setCopy1] = useState(false);
  const CallCopy1 = () => {
    setCopy1(true);
    setTimeout(() => {
      setCopy1(false);
    }, [3000]);
  };
  // const inputHandlerPrivatekey = (e) => {
  //   let value = e.target.value;
  //   setInputPrivateKeyInput(value);
  //   let check = isValidPrivateKey(value);
  //   if (check) {
  //     setErrorBool(false);
  //   } else {
  //     setErrorBool(true);
  //   }
  // };
  // function isValidPrivateKey(pk) {
  //   return /^0x[a-fA-F0-9]{64}$/.test(pk);
  // }
  useEffect(() => {
    if (account) {
      if (trust) {
        handleShowSign();
        setTurst(false);
      }
    }
  }, [account, trust]);

  const signInUser = async () => {
    setLoading(true);
    let tok = localStorage.getItem("token");
    let addrSign = localStorage.getItem("addrSign");
    if (tok && addrSign === account) {
    } else {
      try {
        // setLoader(true)
        let v = await userSign();
        if (v) {
          localStorage.setItem("sign", v);
          // internalAccountHandler()
          localStorage.setItem("addrSign", account);
          // handleCloseSign()
          window.location.reload();
        }
      } catch (err) {
        console.log(err, "user sign error");
        // clearData()
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    const registerSignedUser = async () => {
      const sign = localStorage.getItem("sign");
      const walletAddress = account;
      const userSmartAddress = smartAccount;

      if (walletAddress && userSmartAddress && sign) {
        try {
          const res = await registerWithWallet(
            walletAddress,
            userSmartAddress,
            sign
          );
          if (res?.token) {
            localStorage.setItem("token", res.token);
          }
        } catch (err) {
          console.error("Registration error:", err);
        }
      }
    };

    registerSignedUser();
  }, [account, smartAccount]);

  useEffect(() => {
    let tok = localStorage.getItem("accessToken");
    let addrSign = localStorage.getItem("addrSign");
    if (account) {
      if (tok && addrSign) {
        signInUser();
      }
    }
  }, [account]);

  return (
    <>
      {loading && <Loader />}
      <Modal className="metamodal" show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Connect Wallet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parentbox">
            <div
              className="mainbox d-noneformobile metamask_side"
              onClick={connectWallet}
            >
              <p>
                {theme === "light" ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="46"
                    height="46"
                    viewBox="0 0 46 46"
                    fill="none"
                  >
                    <rect
                      width="46"
                      height="46"
                      rx="23"
                      fill="black"
                      fill-opacity="0.1"
                    />
                    <path
                      d="M34.2691 11.8662L24.4785 19.0583L26.2992 14.8197L34.2691 11.8662Z"
                      fill="#E17726"
                      stroke="#E17726"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11.686 11.8662L21.3894 19.1254L19.656 14.8197L11.686 11.8662Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M30.7437 28.542L28.1387 32.4928L33.7166 34.0176L35.3145 28.6284L30.7437 28.542Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.6494 28.6284L12.2376 34.0176L17.8059 32.4928L15.2106 28.542L10.6494 28.6284Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.506 21.868L15.9565 24.1887L21.4764 24.438L21.2924 18.5405L17.506 21.868Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M28.4489 21.8678L24.6044 18.4731L24.4785 24.4377L29.9983 24.1884L28.4489 21.8678Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.8062 32.4926L21.1471 30.8912L18.271 28.6665L17.8062 32.4926Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.8081 30.8912L28.1394 32.4926L27.6842 28.6665L24.8081 30.8912Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M28.1394 32.493L24.8081 30.8916L25.0792 33.0396L25.0501 33.9506L28.1394 32.493Z"
                      fill="#D5BFB2"
                      stroke="#D5BFB2"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.8062 32.493L20.9051 33.9506L20.8857 33.0396L21.1471 30.8916L17.8062 32.493Z"
                      fill="#D5BFB2"
                      stroke="#D5BFB2"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20.9635 27.2476L18.1938 26.4421L20.15 25.5503L20.9635 27.2476Z"
                      fill="#233447"
                      stroke="#233447"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.9917 27.2476L25.8052 25.5503L27.771 26.4421L24.9917 27.2476Z"
                      fill="#233447"
                      stroke="#233447"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.8062 32.4928L18.2905 28.542L15.2109 28.6284L17.8062 32.4928Z"
                      fill="#CC6228"
                      stroke="#CC6228"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M27.6646 28.542L28.1391 32.4928L30.7441 28.6284L27.6646 28.542Z"
                      fill="#CC6228"
                      stroke="#CC6228"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M29.9983 24.1885L24.4785 24.4378L24.9917 27.2476L25.8052 25.5502L27.7711 26.442L29.9983 24.1885Z"
                      fill="#CC6228"
                      stroke="#CC6228"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.1935 26.442L20.1497 25.5502L20.9632 27.2476L21.4764 24.4378L15.9565 24.1885L18.1935 26.442Z"
                      fill="#CC6228"
                      stroke="#CC6228"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.9565 24.1885L18.271 28.6667L18.1935 26.442L15.9565 24.1885Z"
                      fill="#E27525"
                      stroke="#E27525"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M27.7712 26.442L27.6841 28.6667L29.9986 24.1885L27.7712 26.442Z"
                      fill="#E27525"
                      stroke="#E27525"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M21.4767 24.438L20.9634 27.2477L21.6122 30.5656L21.7575 26.1929L21.4767 24.438Z"
                      fill="#E27525"
                      stroke="#E27525"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.4787 24.438L24.2075 26.1833L24.3431 30.5656L24.9919 27.2477L24.4787 24.438Z"
                      fill="#E27525"
                      stroke="#E27525"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.9916 27.2474L24.3428 30.5653L24.8076 30.8914L27.6838 28.6666L27.7709 26.4419L24.9916 27.2474Z"
                      fill="#F5841F"
                      stroke="#F5841F"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.1938 26.4419L18.2714 28.6666L21.1475 30.8914L21.6123 30.5653L20.9635 27.2474L18.1938 26.4419Z"
                      fill="#F5841F"
                      stroke="#F5841F"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M25.0498 33.9508L25.0788 33.0398L24.8271 32.8288H21.1278L20.8857 33.0398L20.9051 33.9508L17.8062 32.4932L18.8908 33.3754L21.089 34.8809H24.8561L27.064 33.3754L28.1389 32.4932L25.0498 33.9508Z"
                      fill="#C0AC9D"
                      stroke="#C0AC9D"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.8077 30.8914L24.3429 30.5654H21.612L21.1472 30.8914L20.8857 33.0395L21.1279 32.8285H24.8271L25.0789 33.0395L24.8077 30.8914Z"
                      fill="#161616"
                      stroke="#161616"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M34.6857 19.5281L35.5089 15.5581L34.2693 11.8662L24.8081 18.8185L28.4492 21.8679L33.5914 23.3543L34.7245 22.0406L34.2306 21.6857L35.015 20.9762L34.4146 20.5159L35.199 19.9213L34.6857 19.5281Z"
                      fill="#763E1A"
                      stroke="#763E1A"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.4463 15.5581L11.2791 19.5281L10.7465 19.9213L11.5406 20.5159L10.9402 20.9762L11.7246 21.6857L11.2307 22.0406L12.3637 23.3543L17.506 21.8679L21.1471 18.8185L11.6858 11.8662L10.4463 15.5581Z"
                      fill="#763E1A"
                      stroke="#763E1A"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M33.5913 23.3545L28.4491 21.8682L29.9986 24.1888L27.6841 28.667L30.7442 28.6287H35.315L33.5913 23.3545Z"
                      fill="#F5841F"
                      stroke="#F5841F"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.5056 21.8682L12.3635 23.3545L10.6494 28.6287H15.2106L18.2707 28.667L15.9562 24.1888L17.5056 21.8682Z"
                      fill="#F5841F"
                      stroke="#F5841F"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.4784 24.438L24.8076 18.8186L26.299 14.8198H19.6558L21.1471 18.8186L21.4763 24.438L21.6022 26.2024L21.6119 30.5656H24.3428L24.3525 26.2024L24.4784 24.438Z"
                      fill="#F5841F"
                      stroke="#F5841F"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="46"
                    height="46"
                    viewBox="0 0 46 46"
                    fill="none"
                  >
                    <rect
                      width="46"
                      height="46"
                      rx="23"
                      fill="white"
                      fill-opacity="0.08"
                    />
                    <path
                      d="M34.2691 11.8663L24.4785 19.0583L26.2992 14.8198L34.2691 11.8663Z"
                      fill="#E17726"
                      stroke="#E17726"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11.686 11.8663L21.3894 19.1254L19.656 14.8198L11.686 11.8663Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M30.7437 28.5421L28.1387 32.493L33.7166 34.0177L35.3145 28.6285L30.7437 28.5421Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.6494 28.6285L12.2376 34.0177L17.8059 32.493L15.2106 28.5421L10.6494 28.6285Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.506 21.868L15.9565 24.1887L21.4764 24.438L21.2924 18.5405L17.506 21.868Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M28.4489 21.8681L24.6044 18.4734L24.4785 24.4381L29.9983 24.1887L28.4489 21.8681Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.8062 32.4929L21.1471 30.8916L18.271 28.6668L17.8062 32.4929Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.8081 30.8916L28.1394 32.4929L27.6842 28.6668L24.8081 30.8916Z"
                      fill="#E27625"
                      stroke="#E27625"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M28.1394 32.4931L24.8081 30.8917L25.0792 33.0397L25.0501 33.9507L28.1394 32.4931Z"
                      fill="#D5BFB2"
                      stroke="#D5BFB2"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.8062 32.4931L20.9051 33.9507L20.8857 33.0397L21.1471 30.8917L17.8062 32.4931Z"
                      fill="#D5BFB2"
                      stroke="#D5BFB2"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20.9635 27.2476L18.1938 26.4421L20.15 25.5503L20.9635 27.2476Z"
                      fill="#233447"
                      stroke="#233447"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.9917 27.2476L25.8052 25.5503L27.771 26.4421L24.9917 27.2476Z"
                      fill="#233447"
                      stroke="#233447"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.8062 32.493L18.2905 28.5421L15.2109 28.6285L17.8062 32.493Z"
                      fill="#CC6228"
                      stroke="#CC6228"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M27.6646 28.5421L28.1391 32.493L30.7441 28.6285L27.6646 28.5421Z"
                      fill="#CC6228"
                      stroke="#CC6228"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M29.9983 24.1885L24.4785 24.4379L24.9917 27.2476L25.8052 25.5502L27.7711 26.4421L29.9983 24.1885Z"
                      fill="#CC6228"
                      stroke="#CC6228"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.1935 26.4421L20.1497 25.5502L20.9632 27.2476L21.4764 24.4379L15.9565 24.1885L18.1935 26.4421Z"
                      fill="#CC6228"
                      stroke="#CC6228"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.9565 24.1885L18.271 28.6668L18.1935 26.4421L15.9565 24.1885Z"
                      fill="#E27525"
                      stroke="#E27525"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M27.7712 26.4421L27.6841 28.6668L29.9986 24.1885L27.7712 26.4421Z"
                      fill="#E27525"
                      stroke="#E27525"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M21.4767 24.4379L20.9634 27.2476L21.6122 30.5655L21.7575 26.1928L21.4767 24.4379Z"
                      fill="#E27525"
                      stroke="#E27525"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.4787 24.4379L24.2075 26.1832L24.3431 30.5655L24.9919 27.2476L24.4787 24.4379Z"
                      fill="#E27525"
                      stroke="#E27525"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.9916 27.2477L24.3428 30.5656L24.8076 30.8917L27.6838 28.6669L27.7709 26.4422L24.9916 27.2477Z"
                      fill="#F5841F"
                      stroke="#F5841F"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.1938 26.4422L18.2714 28.6669L21.1475 30.8917L21.6123 30.5656L20.9635 27.2477L18.1938 26.4422Z"
                      fill="#F5841F"
                      stroke="#F5841F"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M25.0498 33.9506L25.0788 33.0396L24.8271 32.8287H21.1278L20.8857 33.0396L20.9051 33.9506L17.8062 32.493L18.8908 33.3753L21.089 34.8808H24.8561L27.064 33.3753L28.1389 32.493L25.0498 33.9506Z"
                      fill="#C0AC9D"
                      stroke="#C0AC9D"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.8077 30.8915L24.3429 30.5656H21.612L21.1472 30.8915L20.8857 33.0396L21.1279 32.8286H24.8271L25.0789 33.0396L24.8077 30.8915Z"
                      fill="#161616"
                      stroke="#161616"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M34.6857 19.5282L35.5089 15.5582L34.2693 11.8663L24.8081 18.8186L28.4492 21.868L33.5914 23.3544L34.7245 22.0406L34.2306 21.6858L35.015 20.9762L34.4146 20.5159L35.199 19.9214L34.6857 19.5282Z"
                      fill="#763E1A"
                      stroke="#763E1A"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.4463 15.5582L11.2791 19.5282L10.7465 19.9214L11.5406 20.5159L10.9402 20.9762L11.7246 21.6858L11.2307 22.0406L12.3637 23.3544L17.506 21.868L21.1471 18.8186L11.6858 11.8663L10.4463 15.5582Z"
                      fill="#763E1A"
                      stroke="#763E1A"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M33.5913 23.3543L28.4491 21.868L29.9986 24.1886L27.6841 28.6668L30.7442 28.6285H35.315L33.5913 23.3543Z"
                      fill="#F5841F"
                      stroke="#F5841F"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.5056 21.868L12.3635 23.3543L10.6494 28.6285H15.2106L18.2707 28.6668L15.9562 24.1886L17.5056 21.868Z"
                      fill="#F5841F"
                      stroke="#F5841F"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.4784 24.4379L24.8076 18.8185L26.299 14.8198H19.6558L21.1471 18.8185L21.4763 24.4379L21.6022 26.2024L21.6119 30.5656H24.3428L24.3525 26.2024L24.4784 24.4379Z"
                      fill="#F5841F"
                      stroke="#F5841F"
                      stroke-width="0.201754"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                )}
                MetaMask
              </p>
            </div>
            <div className="mainbox">
              <p
                onClick={() => {
                  trustWallet();
                  handleClose();
                }}
              >
                {theme === "light" ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="46"
                    height="46"
                    viewBox="0 0 46 46"
                    fill="none"
                  >
                    <path
                      d="M0 23C0 10.2975 10.2975 0 23 0C35.7025 0 46 10.2975 46 23C46 35.7025 35.7025 46 23 46C10.2975 46 0 35.7025 0 23Z"
                      fill="black"
                      fill-opacity="0.06"
                    />
                    <path
                      d="M14.5135 17.8214C19.003 13.428 26.2797 13.428 30.7691 17.8214L31.3086 18.3515C31.5318 18.5717 31.5318 18.9282 31.3086 19.1483L29.4608 20.9559C29.3491 21.0644 29.1662 21.0644 29.0546 20.9559L28.3105 20.2273C25.179 17.1641 20.1005 17.1641 16.9691 20.2273L16.1723 21.0055C16.0607 21.114 15.8777 21.114 15.7661 21.0055L13.9183 19.1979C13.695 18.9778 13.695 18.6213 13.9183 18.4011L14.5104 17.8214H14.5135ZM34.592 21.5605L36.2352 23.1696C36.4584 23.3897 36.4584 23.7463 36.2352 23.9664L28.819 31.2245C28.5957 31.4447 28.2299 31.4447 28.0066 31.2245L22.7421 26.0747C22.6863 26.0189 22.5964 26.0189 22.5375 26.0747L17.2729 31.2245C17.0497 31.4447 16.6839 31.4447 16.4606 31.2245L9.04438 23.9664C8.82115 23.7463 8.82115 23.3897 9.04438 23.1696L10.6876 21.5605C10.9108 21.3404 11.2767 21.3404 11.4999 21.5605L16.7645 26.7103C16.8203 26.7661 16.9102 26.7661 16.9691 26.7103L22.2336 21.5605C22.4569 21.3404 22.8227 21.3404 23.0459 21.5605L28.3105 26.7134C28.3663 26.7692 28.4562 26.7692 28.5151 26.7134L33.7797 21.5636C34.0029 21.3435 34.3687 21.3435 34.592 21.5636V21.5605Z"
                      fill="#3999FD"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="46"
                    height="46"
                    viewBox="0 0 46 46"
                    fill="none"
                  >
                    <path
                      d="M0 23C0 10.2975 10.2975 0 23 0C35.7025 0 46 10.2975 46 23C46 35.7025 35.7025 46 23 46C10.2975 46 0 35.7025 0 23Z"
                      fill="white"
                      fill-opacity="0.08"
                    />
                    <path
                      d="M14.5135 17.8213C19.003 13.428 26.2797 13.428 30.7691 17.8213L31.3086 18.3515C31.5318 18.5716 31.5318 18.9282 31.3086 19.1483L29.4608 20.9558C29.3491 21.0644 29.1662 21.0644 29.0546 20.9558L28.3105 20.2272C25.179 17.164 20.1005 17.164 16.9691 20.2272L16.1723 21.0054C16.0607 21.114 15.8777 21.114 15.7661 21.0054L13.9183 19.1979C13.695 18.9778 13.695 18.6212 13.9183 18.4011L14.5104 17.8213H14.5135ZM34.592 21.5604L36.2352 23.1695C36.4584 23.3897 36.4584 23.7462 36.2352 23.9664L28.819 31.2245C28.5957 31.4446 28.2299 31.4446 28.0066 31.2245L22.7421 26.0747C22.6863 26.0188 22.5964 26.0188 22.5375 26.0747L17.2729 31.2245C17.0497 31.4446 16.6839 31.4446 16.4606 31.2245L9.04438 23.9664C8.82115 23.7462 8.82115 23.3897 9.04438 23.1695L10.6876 21.5604C10.9108 21.3403 11.2767 21.3403 11.4999 21.5604L16.7645 26.7102C16.8203 26.7661 16.9102 26.7661 16.9691 26.7102L22.2336 21.5604C22.4569 21.3403 22.8227 21.3403 23.0459 21.5604L28.3105 26.7133C28.3663 26.7692 28.4562 26.7692 28.5151 26.7133L33.7797 21.5635C34.0029 21.3434 34.3687 21.3434 34.592 21.5635V21.5604Z"
                      fill="#3999FD"
                    />
                  </svg>
                )}
                WalletConnect
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/*
      <Modal
        className="editmodal"
        show={showWallet}
        onHide={handleCloseWallet}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Import or Create New Account</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="depositmainboxes">
            <div
              className="depositinnerbox"
              onClick={() => {
                handleCloseWallet();
                handleShowImportSmart();
              }}
            >
              <div className="deposittexts">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  fill="none"
                >
                  <path
                    d="M17 4.25V21.25"
                    stroke="#F24CA2"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.333 15.5833L16.9997 21.25L22.6663 15.5833"
                    stroke="#F24CA2"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.333 7.08337H5.66634C4.91489 7.08337 4.19422 7.38188 3.66287 7.91324C3.13152 8.44459 2.83301 9.16526 2.83301 9.91671V24.0834C2.83301 24.8348 3.13152 25.5555 3.66287 26.0868C4.19422 26.6182 4.91489 26.9167 5.66634 26.9167H28.333C29.0845 26.9167 29.8051 26.6182 30.3365 26.0868C30.8678 25.5555 31.1663 24.8348 31.1663 24.0834V9.91671C31.1663 9.16526 30.8678 8.44459 30.3365 7.91324C29.8051 7.38188 29.0845 7.08337 28.333 7.08337H22.6663"
                    stroke="#F24CA2"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <h6 className="boxhead mb-0">Import Existing Wallet</h6>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                className="arrowimg"
              >
                <path
                  d="M15.5855 9.39828L10.523 14.4608C10.4174 14.5663 10.2743 14.6256 10.125 14.6256C9.97573 14.6256 9.83258 14.5663 9.72703 14.4608C9.62148 14.3552 9.56219 14.2121 9.56219 14.0628C9.56219 13.9135 9.62148 13.7704 9.72703 13.6648L13.8298 9.56281L2.8125 9.56281C2.66332 9.56281 2.52024 9.50355 2.41475 9.39806C2.30926 9.29257 2.25 9.1495 2.25 9.00031C2.25 8.85113 2.30926 8.70805 2.41475 8.60257C2.52024 8.49708 2.66332 8.43781 2.8125 8.43781L13.8298 8.43781L9.72703 4.33578C9.62148 4.23023 9.56219 4.08708 9.56219 3.93781C9.56219 3.78855 9.62148 3.64539 9.72703 3.53984C9.83258 3.4343 9.97573 3.375 10.125 3.375C10.2743 3.375 10.4174 3.4343 10.523 3.53984L15.5855 8.60234C15.6378 8.65458 15.6793 8.71662 15.7076 8.78491C15.7359 8.8532 15.7504 8.92639 15.7504 9.00031C15.7504 9.07423 15.7359 9.14743 15.7076 9.21572C15.6793 9.284 15.6378 9.34604 15.5855 9.39828Z"
                  fill="white"
                />
              </svg>
            </div>
            <div
              className="depositinnerbox"
              onClick={() => {
                handleCloseWallet();
                handleShowCreateSmart();
                internalAccountHandler();
              }}
            >
              <div className="deposittexts">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  fill="none"
                >
                  <path
                    d="M26.9167 9.91667V5.66667C26.9167 5.29094 26.7674 4.93061 26.5017 4.66493C26.2361 4.39926 25.8757 4.25 25.5 4.25H7.08333C6.33189 4.25 5.61122 4.54851 5.07986 5.07986C4.54851 5.61122 4.25 6.33189 4.25 7.08333C4.25 7.83478 4.54851 8.55545 5.07986 9.0868C5.61122 9.61816 6.33189 9.91667 7.08333 9.91667H28.3333C28.7091 9.91667 29.0694 10.0659 29.3351 10.3316C29.6007 10.5973 29.75 10.9576 29.75 11.3333V17M29.75 17H25.5C24.7485 17 24.0279 17.2985 23.4965 17.8299C22.9652 18.3612 22.6667 19.0819 22.6667 19.8333C22.6667 20.5848 22.9652 21.3054 23.4965 21.8368C24.0279 22.3682 24.7485 22.6667 25.5 22.6667H29.75C30.1257 22.6667 30.4861 22.5174 30.7517 22.2517C31.0174 21.9861 31.1667 21.6257 31.1667 21.25V18.4167C31.1667 18.0409 31.0174 17.6806 30.7517 17.4149C30.4861 17.1493 30.1257 17 29.75 17Z"
                    stroke="#F24CA2"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4.25 7.08331V26.9166C4.25 27.6681 4.54851 28.3888 5.07986 28.9201C5.61122 29.4515 6.33189 29.75 7.08333 29.75H28.3333C28.7091 29.75 29.0694 29.6007 29.3351 29.335C29.6007 29.0694 29.75 28.709 29.75 28.3333V22.6666"
                    stroke="#F24CA2"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <h6 className="boxhead mb-0">Create New Account</h6>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                className="arrowimg"
              >
                <path
                  d="M15.5855 9.39828L10.523 14.4608C10.4174 14.5663 10.2743 14.6256 10.125 14.6256C9.97573 14.6256 9.83258 14.5663 9.72703 14.4608C9.62148 14.3552 9.56219 14.2121 9.56219 14.0628C9.56219 13.9135 9.62148 13.7704 9.72703 13.6648L13.8298 9.56281L2.8125 9.56281C2.66332 9.56281 2.52024 9.50355 2.41475 9.39806C2.30926 9.29257 2.25 9.1495 2.25 9.00031C2.25 8.85113 2.30926 8.70805 2.41475 8.60257C2.52024 8.49708 2.66332 8.43781 2.8125 8.43781L13.8298 8.43781L9.72703 4.33578C9.62148 4.23023 9.56219 4.08708 9.56219 3.93781C9.56219 3.78855 9.62148 3.64539 9.72703 3.53984C9.83258 3.4343 9.97573 3.375 10.125 3.375C10.2743 3.375 10.4174 3.4343 10.523 3.53984L15.5855 8.60234C15.6378 8.65458 15.6793 8.71662 15.7076 8.78491C15.7359 8.8532 15.7504 8.92639 15.7504 9.00031C15.7504 9.07423 15.7359 9.14743 15.7076 9.21572C15.6793 9.284 15.6378 9.34604 15.5855 9.39828Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
        </Modal.Body>
      </Modal> */}

      {/* <Modal
        className="editmodal"
        show={showImportSmart}
        onHide={handleCloseImportSmart}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Import Existing Wallet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="main-content">
            <div className="main-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="38"
                height="39"
                viewBox="0 0 38 39"
                fill="none"
              >
                <path
                  d="M26.916 22.6667H26.9335"
                  stroke="#F24CA2"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.0833 11.5833H30.0833C30.9232 11.5833 31.7286 11.917 32.3225 12.5108C32.9164 13.1047 33.25 13.9101 33.25 14.75V30.5833C33.25 31.4232 32.9164 32.2286 32.3225 32.8225C31.7286 33.4164 30.9232 33.75 30.0833 33.75H7.91667C7.07681 33.75 6.27136 33.4164 5.6775 32.8225C5.08363 32.2286 4.75 31.4232 4.75 30.5833V8.41667C4.75 7.57681 5.08363 6.77136 5.6775 6.1775C6.27136 5.58363 7.07681 5.25 7.91667 5.25H30.0833"
                  stroke="#F24CA2"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <h5 className="accesshead">Access Your Wallet</h5>
            <p className="accesspara">
              Import your private key to continue, or connect a different wallet
              to create a new one.
            </p>
            <textarea
              className="accesstextarea"
              type="text"
              placeholder="0x..."
              value={inputPrivateKeyInput}
              onChange={(e) => {
                inputHandlerPrivatekey(e);
              }}
            ></textarea>
            {errorBool && <p className="errorpara">{errorMessage}</p>}
          </div>
          <div className="bottom-btns">
            <button onClick={handleCloseImportSmart} className="closebtn">
              Close
            </button>
            <button
              onClick={() => {
                toast.success("Your account has been successfully imported.");
                handleCloseImportSmart();
                internalAccountHandler(inputPrivateKeyInput);
              }}
              className="depositbtn"
              disabled={
                !inputPrivateKeyInput || +inputPrivateKeyInput == 0 || errorBool
                  ? true
                  : false
              }
            >
              Import
            </button>
          </div>
        </Modal.Body>
      </Modal> */}

      <Modal
        className="editmodal"
        show={showCreateSmart}
        onHide={handleCloseCreateSmart}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Create New Account</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="main-content">
            <div className="main-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <path
                  d="M28.3333 23.3333H28.3508"
                  stroke="#F24CA2"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.6667 11.6667H31.6667C32.5507 11.6667 33.3986 12.0179 34.0237 12.643C34.6488 13.2681 35 14.1159 35 15V31.6667C35 32.5507 34.6488 33.3986 34.0237 34.0237C33.3986 34.6488 32.5507 35 31.6667 35H8.33333C7.44928 35 6.60143 34.6488 5.97631 34.0237C5.35119 33.3986 5 32.5507 5 31.6667V8.33333C5 7.44928 5.35119 6.60143 5.97631 5.97631C6.60143 5.35119 7.44928 5 8.33333 5H31.6667"
                  stroke="#F24CA2"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <h5 className="accesshead">Wallet Created</h5>
            <p className="accesspara">
              Save your private key securely — it's the only way to access your
              Luckify wallet.{" "}
              <span className="textred">Losing it means losing your funds</span>
              .
            </p>
            <div className="wallet-parent">
              <div className="wallet-address">
                <p>Wallet Address:</p>
                <div className="address-copy-text">
                  <h6>
                    {" "}
                    {smartAccount?.substring(0, 6)}...
                    {smartAccount?.substring(smartAccount?.length - 6)}
                  </h6>
                  <CopyToClipboard
                    text={smartAccount}
                    onCopy={() => CallCopy1()}
                  >
                    {copy1 ? (
                      <h6 className="copied">copied</h6>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <path
                          d="M9.33366 7.52496V9.97496C9.33366 12.0166 8.51699 12.8333 6.47533 12.8333H4.02533C1.98366 12.8333 1.16699 12.0166 1.16699 9.97496V7.52496C1.16699 5.48329 1.98366 4.66663 4.02533 4.66663H6.47533C8.51699 4.66663 9.33366 5.48329 9.33366 7.52496Z"
                          stroke="#F24CA2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12.8337 4.02496V6.47496C12.8337 8.51663 12.017 9.33329 9.97533 9.33329H9.33366V7.52496C9.33366 5.48329 8.51699 4.66663 6.47533 4.66663H4.66699V4.02496C4.66699 1.98329 5.48366 1.16663 7.52533 1.16663H9.97533C12.017 1.16663 12.8337 1.98329 12.8337 4.02496Z"
                          stroke="#F24CA2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    )}
                  </CopyToClipboard>
                </div>
              </div>
              <div className="private-box">
                <p>Private Key</p>
                <h6>{privatekeyy}</h6>
              </div>
            </div>
          </div>
          <div className="bottom-btns">
            <button
              onClick={handleCloseCreateSmart}
              className="closebtn btnpaddset"
            >
              Close
            </button>
            <CopyToClipboard text={privatekeyy} onCopy={() => CallCopy()}>
              {copy ? (
                <button className="depositbtn btnpaddset">
                  <h6 className="copied">copied</h6>
                </button>
              ) : (
                <button className="depositbtn btnpaddset">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M10.6673 8.59998V11.4C10.6673 13.7333 9.73398 14.6666 7.40065 14.6666H4.60065C2.26732 14.6666 1.33398 13.7333 1.33398 11.4V8.59998C1.33398 6.26665 2.26732 5.33331 4.60065 5.33331H7.40065C9.73398 5.33331 10.6673 6.26665 10.6673 8.59998Z"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.6673 4.59998V7.39998C14.6673 9.73331 13.734 10.6666 11.4007 10.6666H10.6673V8.59998C10.6673 6.26665 9.73398 5.33331 7.40065 5.33331H5.33398V4.59998C5.33398 2.26665 6.26732 1.33331 8.60065 1.33331H11.4007C13.734 1.33331 14.6673 2.26665 14.6673 4.59998Z"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  COPY Private Key
                </button>
              )}
            </CopyToClipboard>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="editmodal signmodal"
        show={showsign}
        onHide={handleCloseSign}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Sign To Continue</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mainuppercontent my-3">
            <h6>Please provide sign to continue</h6>
          </div>
          <div className="bottom-btns">
            <button className="depositbtn" onClick={signInUser}>
              SIGN
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default WalletConnectModel;
